import { Theme } from "@mui/material/styles";

export const modernDataGridStyles = (theme: Theme) => ({
  border: "none",
  borderRadius: "16px",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  backdropFilter: "blur(20px)",
  boxShadow: "0 8px 32px rgba(140, 150, 169, 0.15)",
  overflow: "hidden",
  "& .MuiDataGrid-main": {
    borderRadius: "16px",
  },
  "& .MuiDataGrid-cell": {
    borderColor: "rgba(140, 150, 169, 0.1)",
    padding: "12px 16px",
    fontSize: "0.875rem",
    transition: "all 0.2s ease",
  },
  "& .MuiDataGrid-columnHeaders": {
    background: `linear-gradient(135deg, rgb(140, 150, 169) 0%, rgba(140, 150, 169, 0.9) 100%)`,
    borderRadius: "16px 16px 0 0",
    color: "white",
    fontSize: "0.9rem",
    fontWeight: 600,
    minHeight: "56px !important",
    "& .MuiDataGrid-columnHeader": {
      padding: "12px 16px",
      "&:focus, &:focus-within": {
        outline: "none",
      },
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: "0.875rem",
      color: "white",
    },
    "& .MuiDataGrid-iconSeparator": {
      color: "rgba(255, 255, 255, 0.5)",
    },
    "& .MuiDataGrid-sortIcon": {
      color: "white",
    },
    "& .MuiDataGrid-menuIcon": {
      color: "white",
    },
  },
  "& .MuiDataGrid-row": {
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(140, 150, 169, 0.02)",
    },
    "&:hover": {
      backgroundColor: "rgba(251, 171, 53, 0.1)",
      transform: "translateX(4px)",
      boxShadow: "4px 0 12px rgba(251, 171, 53, 0.2)",
      "& .action-buttons": {
        "& .MuiIconButton-root": {
          opacity: 1,
          transform: "scale(1)",
        },
      },
    },
    "&.Mui-selected": {
      backgroundColor: "rgba(251, 171, 53, 0.15)",
      "&:hover": {
        backgroundColor: "rgba(251, 171, 53, 0.2)",
      },
    },
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid rgba(140, 150, 169, 0.1)",
    backgroundColor: "rgba(140, 150, 169, 0.05)",
    borderRadius: "0 0 16px 16px",
  },
  "& .MuiTablePagination-root": {
    color: "rgb(140, 150, 169)",
  },
  "& .MuiDataGrid-selectedRowCount": {
    color: "rgb(251, 171, 53)",
    fontWeight: 600,
  },
  "& .MuiDataGrid-toolbarContainer": {
    padding: "16px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderBottom: "1px solid rgba(140, 150, 169, 0.1)",
    "& .MuiButton-root": {
      borderRadius: "8px",
      textTransform: "none",
      fontWeight: 600,
    },
  },
  "& .MuiLinearProgress-root": {
    backgroundColor: "rgba(251, 171, 53, 0.2)",
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgb(251, 171, 53)",
    },
  },
  "& .MuiDataGrid-overlay": {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(10px)",
  },
});

export const modernIconButtonStyles = (theme: Theme) => ({
  backgroundColor: "rgb(140, 150, 169)",
  color: "white",
  margin: "0 2px",
  borderRadius: "10px",
  padding: "6px",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  boxShadow: "0 2px 8px rgba(140, 150, 169, 0.3)",
  opacity: 0,
  transform: "scale(0.8)",
  "&:hover": {
    backgroundColor: "rgb(251, 171, 53)",
    transform: "translateY(-2px) scale(1.05)",
    boxShadow: "0 4px 16px rgba(251, 171, 53, 0.4)",
  },
  "&:active": {
    transform: "translateY(0px) scale(1)",
  },
});

export const visibleIconButtonStyles = (theme: Theme) => ({
  ...modernIconButtonStyles(theme),
  opacity: 1,
  transform: "scale(1)",
});
